import { combineReducers } from 'redux'
import { firebaseReducer } from 'react-redux-firebase'

import * as GlobalReducer from './global'
import * as UserReducer from './user'
import * as NewsReducer from './news'

export default combineReducers({
  ...GlobalReducer,
  ...UserReducer,
  ...NewsReducer,
  firebase: firebaseReducer,
})
